import { render, staticRenderFns } from "./PostShow.vue?vue&type=template&id=6dc30de7&"
import script from "./PostShow.vue?vue&type=script&lang=js&"
export * from "./PostShow.vue?vue&type=script&lang=js&"
import style0 from "./PostShow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports